export default function ServicesCTA() {
  return (
    <section id="contact" className="bg-black py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-[800px] mx-auto text-center">
          <p className="text-[16px] md:text-[18px] text-[#C0C0C0] mb-10 leading-relaxed">
            Schedule a consultation to discuss your specific training needs. We'll design a program tailored to your operational environment, team composition, and risk profile.
          </p>

          <a 
            href="#consultation" 
            className="inline-block px-8 py-4 bg-[#D4C4B0] text-black text-[14px] font-semibold text-center rounded-lg hover:bg-[#C4B4A0] transition-all duration-300 whitespace-nowrap cursor-pointer mb-8"
          >
            Request Consultation
          </a>

          <p className="text-[16px] md:text-[18px] text-[#C0C0C0]">
            concierge@ufirstdoctorselite.com
          </p>
        </div>
      </div>
    </section>
  );
}
